import { openBlock as t, createElementBlock as e, createElementVNode as l } from "vue";
const o = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 40 40"
}, n = /* @__PURE__ */ l("path", {
  fill: "#F0F0F0",
  d: "M20 40c11.046 0 20-8.954 20-20S31.046 0 20 0 0 8.954 0 20s8.954 20 20 20Z"
}, null, -1), h = /* @__PURE__ */ l("path", {
  fill: "#D80027",
  d: "M0 20C0 8.954 8.954 0 20 0s20 8.954 20 20"
}, null, -1), s = /* @__PURE__ */ l("path", {
  fill: "#F0F0F0",
  d: "M12.174 10.435a6.088 6.088 0 0 1 4.782-5.946 6.087 6.087 0 1 0 0 11.89 6.088 6.088 0 0 1-4.782-5.944ZM20 4.783l.431 1.328h1.397l-1.13.821.432 1.329L20 7.44l-1.13.82.431-1.328-1.13-.82h1.397L20 4.781Z"
}, null, -1), c = /* @__PURE__ */ l("path", {
  fill: "#F0F0F0",
  d: "m16.611 7.391.432 1.329h1.397l-1.13.821.431 1.329-1.13-.821-1.13.82.432-1.328-1.13-.821h1.396l.432-1.329Zm6.778 0 .431 1.329h1.397l-1.13.821.432 1.329-1.13-.821-1.13.82.431-1.328-1.13-.821h1.397l.432-1.329Zm-1.305 3.913.432 1.329h1.397l-1.13.821.431 1.329-1.13-.822-1.13.822.432-1.329-1.13-.821h1.396l.432-1.329Zm-4.169 0 .432 1.329h1.397l-1.13.821.431 1.329-1.13-.822-1.13.822.432-1.329-1.13-.821h1.397l.431-1.329Z"
}, null, -1), i = [
  n,
  h,
  s,
  c
];
function d(_, r) {
  return t(), e("svg", o, [...i]);
}
const m = { render: d };
export {
  m as default,
  d as render
};
